import { computed } from 'vue'
import { useBooksySegment, isBooksyCom } from '@booksy-com/vue-tools'
import { useAnalyticsCommonParams } from './common-params.js'

import { SEGMENT_KEYS } from './consts.js'

let INSTANCE = null

const SEGMENT_KEY = isBooksyCom()
  ? SEGMENT_KEYS.PRODUCTION
  : SEGMENT_KEYS.TEST

export function createSegment () {
  if (!INSTANCE) {
    const {
      country,
      businessId,
      userId,
    } = useAnalyticsCommonParams()

    const userTraits = computed(() => ({
      ...(businessId.value && { business_id: businessId.value }),
      ...(country.value && { country: country.value }),
      ...(userId.value && { userId: userId.value }),
    }))

    INSTANCE = useBooksySegment({
      writeKey: SEGMENT_KEY,
      userTraits,
    })
  }

  return INSTANCE
}
